import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  CircularProgress,
} from "@mui/material";
import { addCOE, updateCOE } from '../../../services/adminServices/CoeServices';
import { toast } from "react-toastify";

const INITIAL_FORM_STATE = {
  COE: "",
  labDetails: "",
  latitude: "",
  longitude: "",
  distance: "",
};

const COEModal = ({ open, onClose, fetchData, rowData,labAdmins }) => {
  const [formValues, setFormValues] = useState(INITIAL_FORM_STATE);
  const [formErrors, setFormErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setFormValues(INITIAL_FORM_STATE);
      setFormErrors({});
    }
  }, [open]);
  useEffect(() => {
    if (rowData!=null) {
      setFormValues({
        COE: rowData.name || '',
        labDetails: rowData.coe_detail || '',
        latitude: rowData.latitude || '',
        longitude: rowData.longitude || '',
        distance: rowData.geo_fencing_distance
      });
    }
   else{
    setFormValues(INITIAL_FORM_STATE);
   }
   setFormErrors({});

  }, [rowData]);

  const handleInputChange = ({ target: { name, value } }) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const validateFields = () => {
    const errors = {};
    const { COE, labDetails, latitude, longitude, distance } = formValues;
    // const coeRegex = /^[A-Za-z_]+$/ ;
    if (!COE) errors.COE = "COE is required*";
    // else if (!coeRegex.test(COE)) errors.COE = "COE can only contain alphabets and underscores*";

    if (!labDetails) errors.labDetails = "Lab Details is required*";

    const latitudeRegex = /^-?([1-8]?[0-9](\.[0-9]+)?|90(\.0+)?)/;
    if (!latitude) errors.latitude = "Latitude is required*";
    else if (!latitudeRegex.test(latitude)) errors.latitude = "Invalid latitude format*";

    const longitudeRegex = /^-?([1-9]?[0-9](\.[0-9]+)?|1[0-7][0-9](\.[0-9]+)?|180(\.0+)?)/;
    if (!longitude) errors.longitude = "Longitude is required*";
    else if (!longitudeRegex.test(longitude)) errors.longitude = "Invalid longitude format*";

    const distanceRegex = /^[1-9]\d*$/;
    if (!distance) errors.distance = "Geo Fencing Distance is required*";
    else if (!distanceRegex.test(distance)) errors.distance = "Geo Fencing Distance must be a positive number";

    return errors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = validateFields();
    if (Object.keys(errors).length) {
      setFormErrors(errors);
      return;
    }

    const addCOERequest = {
      name: formValues.COE,
      coe_detail: formValues.labDetails,
      latitude: formValues.latitude,
      longitude: formValues.longitude,
      geo_fencing_distance: formValues.distance,
      is_active: true
    }
    setIsLoading(true);

    try {
      if (rowData) {
        const response = await updateCOE(rowData.id, addCOERequest);
        toast.success(response.data.message);

      } else {
        const response = await addCOE(addCOERequest);
        toast.success(response.data.message);
      }
      setFormValues(INITIAL_FORM_STATE);
      rowData=null;
      fetchData();
      onClose();

    } catch (error) {
      toast.error( error?.response?.data.message||error?.message ||error?.error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} BackdropProps={{ onClick: onClose }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "45%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          {rowData!=null ? `Edit COE` : `Create COE `}
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {[
              { label: "COE *", name: "COE" },
              { label: "COE Details *", name: "labDetails" },
              { label: "Latitude *", name: "latitude" },
              { label: "Longitude *", name: "longitude" },
              { label: "Geo Fencing Distance *", name: "distance", unit: "meters" },
            ].map(({ label, name, unit }) => (
              <Grid item xs={12} key={name}>
                <TextField
                  fullWidth
                  size="small"
                  label={label}
                  name={name}
                  value={formValues[name]}
                  onChange={handleInputChange}
                  error={!!formErrors[name]}
                  helperText={formErrors[name]}
                  InputProps={{
                    endAdornment: unit && <Typography variant="body2" sx={{ ml: 1 }}>{unit}</Typography>,
                  }}
                />
              </Grid>
            ))}
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Button type="submit" variant="contained" color="primary" disabled={isLoading} sx={{ marginRight: 2 }}>
                {isLoading ? <CircularProgress size={24} /> : rowData ? `Edit` : `Create`
                }
              </Button>
              <Button variant="outlined" color="secondary" onClick={onClose}>Cancel</Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default COEModal;
